
export type UpdateDraftLectureContentBody = {
  /** 업데이트할 마크다운 파일 (.md) */
  markdownFile?: Blob;
  /** 업데이트할 강의 제목 (선택 사항) */
  title?: string;
};
